<template>
  <div>
    <!-- 面包屑导航 -->
    <breadcrumb-top :breadcrumbConfig="dataList"></breadcrumb-top>
    <!-- 面包屑导航 -->
    <div class="content c-top">
      <breadcrumb-search :breadcrumbSearch="searchList"></breadcrumb-search>
      <div style="padding-bottom: 18px">
        <el-form :inline="true" :model="searchForm" ref="searchForm" class="search-form" size="small">
          <el-form-item label="订单编号" prop="orderNo">
            <el-input placeholder="请输入订单编号" v-model="searchForm.orderNo"></el-input>
          </el-form-item>
          <el-form-item label="商品名称" prop="goodsName">
            <el-input placeholder="请输入商品名称" v-model="searchForm.goodsName"></el-input>
          </el-form-item>
          <el-form-item label="类型" prop="type">
            <el-select v-model="searchForm.type" placeholder="请选择类型" filterable clearable>
              <el-option label="下单" value="1"></el-option>
              <el-option label="退款" value="2"></el-option>
              <el-option label="取消" value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <el-select v-model="searchForm.status" placeholder="请选择状态" filterable clearable>
              <el-option v-for="item in brandList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
              <el-option label="待审核" value="1"></el-option>
              <el-option label="已扣除" value="2"></el-option>
              <el-option label="已退回" value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="时间" prop="updatedTimeStart">
            <el-date-picker style="width: 250px" v-model="value1" type="daterange" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy - MM - dd" value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="fetchData('search')">查询</el-button>
            <el-button type="primary" plain @click="fetchData('reset')">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="content">
      <div class="title">
        <h3>列表数据</h3>
        <div>
          <el-button type="primary" icon="el-icon-upload2" :loading="exporting" @click="exportFreezeList">导出</el-button>
        </div>
      </div>
      <div id="base-list">
        <lb-table v-loading="loading" v-horizontal-scroll="'always'" :column="columns" :data="list" pagination
          :total="page.totalNum" layout="total, sizes, prev, pager, next, jumper" :page-sizes="[5, 10, 20, 30, 50]"
          :current-page.sync="page.currentPage" :page-size="page.pageSize" @selection-change="onMultipleSelection"
          @size-change="handleSizeChange" @p-current-change="handleCurrentChange">
        </lb-table>
      </div>
    </div>
  </div>
</template>
<script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
import breadcrumbSearch from '../../../components/breadcrumbSearch.vue'
import LbTable from '../../../components/lb-table/lb-table'
export default {
  components: {
    breadcrumbTop,
    breadcrumbSearch,
    LbTable,
  },
  data() {
    return {
      dataList: {
        list: [
          { title: '财务管理', path: '/financeManagement/platformDeposit', type: '0' },
          { title: '平台保证金', path: '/financeManagement/platformDeposit', type: '1' },
          { title: '冻结金额', path: '', type: '2' }
        ]
      },
      searchList: {
        list: [
          { title: '冻结金额', path: '', type: '0' },
          { title: '数据筛选', path: '', type: '1' }
        ]
      },
      records: [
        {
          img: require('../../../assets/icon_yichongzhi.png'),
          title: '已充值金额',
          price: '10000'
        },
        {
          img: require('../../../assets/icon_dongjie.png'),
          title: '冻结金额',
          price: '10000'
        },
        {
          img: require('../../../assets/icon_keyong.png'),
          title: '可用金额',
          price: '10000'
        },
      ],
      searchTitle: {
        list: [
          { title: '平台保证金', path: '', type: '0' }
        ]
      },
      list: [],
      searchForm: {
        orderNo: '', // 	订单编号
        goodsName: '', // 	商品名称
        type: '', // 	否 	类型 1下单2退款
        status: '', // 	状态 1待审核2已扣除3已退回
        updatedTimeStart: '', // 	
        updatedTimeEnd: '' // 	
      },
      value1: [],
      brandList: [],
      columns: [
        { type: 'selection', minWidth: '80', fixed: 'left' },
        { label: '时间', prop: 'updatedTime', minWidth: '120' },
        { label: '类型', prop: 'typeLabel', minWidth: '120' },
        { label: '订单编号', prop: 'orderNo', minWidth: '220' },
        { label: '商品', prop: 'goodsName', minWidth: '220' },
        { label: '数量', prop: 'goodsNum', minWidth: '80' },
        { label: '金额（元）', prop: 'amount', minWidth: '150' },
        { label: '状态', prop: 'statusLabel', minWidth: '80' },
      ],
      page: { pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
      loading: false,
      exporting: false,
    }
  },
  created() {
    this.getFreezePageList()
  },
  methods: {
    exportFreezeList() {
      this.exporting = true
      if (this.value1.length > 0) {
        this.searchForm.createdTimeStart = this.value1[0];
        this.searchForm.createdTimeEnd = this.value1[1];
      } else {
        this.searchForm.createdTimeStart = ''
        this.searchForm.createdTimeEnd = ''
      }
      this.axios.post('/earnestMoney/exportFreezeList', this.searchForm)
        .then(res => {
          console.log(res)
          this.exporting = false;
          if (res.code == 0) {
            this.downloadlink(res.data)
          }
        })
    },
    fetchData(type) {
      this.page.pageNo = 1;
      if (type == 'reset') {
        this.$refs['searchForm'].resetFields()
        this.value1 = []
      }
      this.getFreezePageList()
    },
    getFreezePageList() {
      if (this.value1) {
        this.searchForm.updatedTimeStart = this.value1[0];
        this.searchForm.updatedTimeEnd = this.value1[1];
      } else {
        this.searchForm.updatedTimeStart = ''
        this.searchForm.updatedTimeEnd = ''
      }
      this.searchForm.pageNo = this.page.pageNo;
      this.searchForm.pageSize = this.page.pageSize;
      this.axios.post('/earnestMoney/getFreezePageList', this.searchForm)
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.list = res.data.list;
            this.page.totalNum = res.data.totalNum;
          }
        })
    },
    onMultipleSelection(e) { },
    handleSizeChange(e) {
      this.page.pageSize = e;
      this.page.pageNo = 1;
      this.getFreezePageList()
    },
    handleCurrentChange(e) {
      this.page.pageNo = e;
      this.getFreezePageList()
    },
    todetail() {
      this.$router.push({
        name: 'userDetail',
        query: {}
      })
    }
  }
}
</script>

<style scoped lang="scss">
.record-item {
  display: flex;
  width: 313px;
  height: 88px;
  background: #ffffff;
  box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.05);
  opacity: 1;
  border-radius: 6px;
  margin-right: 18px;

  img {
    padding: 16px 14px;
  }

  .right {
    margin-top: 16px;

    .title {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 21px;
      color: #303033;
    }

    .price {
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      line-height: 31px;
      color: #303033;
    }
  }
}

.title {
  display: flex;
  justify-content: space-between;
}

#base-list {
  margin-top: 20px;
}

:deep(#base-list .lb-table .el-table .el-table__body .el-table__row .el-table__cell:last-child .cell div) {
  display: inline-block;

  a {
    margin: 0 5px;
  }
}

.search-form {
  // margin-top: 20px;
  display: flex;
  flex-wrap: wrap;

  .el-form-item {
    /deep/ .el-form-item__label {
      width: 70px;
      text-align: right;
      vertical-align: middle;
      float: left;
      box-sizing: border-box;
    }

    /deep/ .el-form-item__content {
      display: block;
      margin-left: 70px;

      .el-cascader,
      .el-select {
        width: 100%;
      }
    }
  }
}

/deep/ .el-table {
  color: #303033
}
</style>

